<template>
    <div :class="{'TQ_grid_col_auto1fr ' : p_verticalLayout_b}">

        <!-- top -->
        <div :class="{TQ_textAlign_initial : p_verticalLayout_b}" class="TQ_bg_gray4 " v-if="p_windowSizeType_e > enum_screenSizesOptions_n.tablet_small">

            <div v-if="p_title_blc_s" class="TQ_bold TQ_text_20px TQ_text_underline TQ_margin_4px TQ_padding_8px">
                {{p_title_blc_s[p_system_langCode_e]}}
            </div>

            <!-- tabs-->
            <component :is="pe_onChangeOrder_f? draggable : 'div'"
                       v-model="local_tabs_ao"
                       :class="{'TQ_inline' : !p_verticalLayout_b, 'TQ_margin_4px' : p_verticalLayout_b}"
                       @update="pe_onChangeOrder_f(local_tabs_ao)">

                <div :class="{'TQ_inline' : !p_verticalLayout_b, 'TQ_maxWidth_200px' : p_verticalLayout_b}"
                     @click="clickTab(index)"
                     v-for="(tab_o,index) in local_tabs_ao"
                     :data-hook="DataHooks_o.tq_tabs"
                     :key="index">

                    <on-top-container>
                        <div class="tabText TQ_textAlign_initial "
                             slot="body"
                             :class="{
                            ['selectedTab TQ_Animation_move2 ' + p_selectedTabClass_s]: m_dom_selectedTab_b(index),
                            [p_tabsClass_s]        : true,}">
                            <img v-if="tab_o.img_s && tab_o.imgSelected_s"
                                 :src="m_dom_selectedTab_b(index) ? tab_o.imgSelected_s : tab_o.img_s" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                            <div v-if="tab_o.img_s" class="TQ_padding_4px TQ_inline"> </div>
                            <div class="TQ_inline TQ_verticalAlignMiddle"> {{m_dom_getTabTitle_fs(tab_o, index)}} </div>
                                                        
                        </div>

                        <tq-btn-approve
                                v-if="pe_deleteTab_click_f"
                                class="classDelete TQ_clickable"
                                slot="topRight"
                                :approve-cb="() => {pe_deleteTab_click_f(index)}"
                                :popup-text="p_deleteTab_approveText_cla_s"
                                :system-lang-code="p_system_langCode_e">
                            <img :src="ass_img_closeRed"
                                 class="TQ_width_20px TQ_borderRadius TQ_verticalAlignMiddle"/>
                            <div class="TQ_padding_4px TQ_inline"> </div> <!-- space -->
                        </tq-btn-approve>

                        <div class="style_Notification"
                             :style="{'zIndex' : gv_zIndex.tqTabs_notification}"
                             slot="topRight"
                             v-else-if="p_tabsNotification_byTabIndex_n[index] > 0">
                            {{p_tabsNotification_byTabIndex_n[index]}}
                        </div>

                    </on-top-container>


                </div>

            </component>

            <!--add tab button -->
            <div class="TQ_bg_green TQ_text_bold TQ_clickable"
                 :class="{'TQ_margin_4px' : p_verticalLayout_b, [p_tabsClass_s] : true}"
                 v-if="pe_addTab_click_f" @click="pe_addTab_click_f">
                <img :src="ass_img_add_w" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                <div class="TQ_padding_4px TQ_inline"> </div> <!-- space -->
                <div class="TQ_inline TQ_verticalAlignMiddle">{{p_addTabText_s}}</div>
            </div>


        </div>

        <!-- mobile menu-->
        <tq-dropdown v-else class="TQ_inline TQ_padding_8px" :show-caret-down="false"
                     :style="{'zIndex' : gv_zIndex.tqTabs_mobileMenu}"
                     :class="helper_getDirectionByLangCode_fe(p_system_langCode_e)  ===  enum_directions.rtl ? 'lc_menuRTL' : 'lc_menuLTR'" >
            <div slot="select"> <tq-image :pb_src_r="ass_img_menu_b" class="TQ_width_44px " /> </div>
            <div slot="options" v-for="(tab_o,index_n) in local_tabs_ao" :key="index_n"
                 @click="clickTab(index_n)"
                 :class="{ 'TQ_bg_purple' : m_dom_selectedTab_b(index_n)}"
                 class="TQ_padding_8px TQ_border_bottom TQ_clickable TQ_text_20px">
                 {{m_dom_getTabTitle_fs(tab_o, index_n)}}
            </div>
        </tq-dropdown>
        <!-- body-->
        <div class="body" :style="{'padding' : p_paddingBody_s}" :key="p_selectedTabIndex_vn.val">
            <slot ></slot>
        </div>
  </div>

</template>

<script>
  import NotificationContainer from "./TqNotificationContainer";
  import OnTopContainer from "./TqOnTopContainer";
  import draggable from 'vuedraggable'
  import {enum_directions, enum_langCodes, enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
  import {
      validator_enum_fb,
      validator_onjKeysByEnumVal_fb,
  } from "../../../functions/src/shareCode/Share_S_Validator";
  import {
      ass_img_add_w, ass_img_closeRed,
      ass_img_garbage_w, ass_img_menu_b,
      ass_img_xLetter_b,
      ass_img_xLetter_r,
      ass_img_xLetter_w
  } from "../../assets/scripts/Ass_Files";
  import TqBtnApprove from "../basic2/TqBtnApprove";
  import {gv_zIndex} from "../../scripts/S_GlobalVar";
  import {validator_array_fb, validator_null_fb} from "../../../functions/src/shareCode/Share_S_Validator";
  import TqDropdown from "@/components/basic/TqDropdown";
  import TqImage from "@/components/basic/TqImage";
  import {helper_getDirectionByLangCode_fe} from "@/scripts/S_Helper";
  import { DataHooks_o } from "@/scripts/S_DataHooks";


  export default {
      name: "TqTabs",
      components: {
          TqImage,
          TqDropdown,
          TqBtnApprove,
          OnTopContainer,
          NotificationContainer,
          draggable
      },
      props:{

          //  ======= core =========
          p_tabs_ao:{
              type:Array,
              require: true,
              validator(val){
                  return validator_array_fb(val)
              }
          },
          p_system_langCode_e:{
              type:String,
              require: true,
          },
          p_display_langCode_e:{
              type:String,
          },
          p_selectedTabIndex_vn : {
              type:Object,
              require: true
          },
          p_windowSizeType_e:{
              type: Number,
              default: enum_screenSizesOptions_n.laptop,
              validator(val_n){
                  return validator_enum_fb(enum_screenSizesOptions_n, val_n)
              }
          },

          // need to have att or p_titlePrefix_s
          p_att_s:{
              type: String
          },
          p_tabTitlePrefix_blc_s:{
              type: Object,
              validator(obj){
                  return validator_null_fb(obj) || validator_onjKeysByEnumVal_fb(obj, enum_langCodes)
              }
          },

          //  ======= notification =========
          p_tabsNotification_byTabIndex_n:{
              type: Object,
              default: () => {return {}}
          },

          //  ======= reorder =========
          pe_onChangeOrder_f:{
              type: Function,
          },

          //  ======= style =========
          p_verticalLayout_b:{
              type:Boolean,
              default : false
          },
          p_paddingBody_s:{
              type: String,
          },
          p_tabsClass_s :{
              type: String,
              default : 'TQ_text_20px TQ_padding_16px_20px'
          },
          p_selectedTabClass_s:{
              type: String,
          },

          //  ======= title =========
          p_title_blc_s:{
              type: Object,
          },

          //  ======= add Tab =========
          p_addTabText_s:{
              type: String,
              default : 'New Tab'
          },
          pe_addTab_click_f:{
              type: Function,
          },
          p_addTab_class_s:{
              type: String,
              default : 'TQ_bg_green'
          },

          //  ======= delete Tab =========
          pe_deleteTab_click_f:{
              type: Function,
          },
          p_deleteTab_approveText_cla_s:{
              type: Object,
          }

      },
      data(){
          return {
              local_tabs_ao     : this.p_tabs_ao,
              draggable         : draggable,
              ass_img_add_w     : ass_img_add_w,
              ass_img_garbage_w : ass_img_garbage_w,
              ass_img_xLetter_r : ass_img_xLetter_r,
              ass_img_xLetter_w : ass_img_xLetter_w,
              ass_img_xLetter_b : ass_img_xLetter_b,
              ass_img_closeRed : ass_img_closeRed,
              ass_img_menu_b : ass_img_menu_b,
              gv_zIndex : gv_zIndex,
              enum_screenSizesOptions_n : enum_screenSizesOptions_n,
              helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe,
              enum_directions : enum_directions,
              DataHooks_o

          }
      },
      methods:{
          m_dom_selectedTab_b(index_n){
              return index_n === this.p_selectedTabIndex_vn.val
          },
          clickTab(index){
              this.p_selectedTabIndex_vn.val = index
          },
          m_dom_getTabTitle_fs(tab_o, index_n){
              let ans_s;

              if(this.p_att_s != null){
                  if(this.p_display_langCode_e != null){
                      ans_s = tab_o[this.p_att_s][this.p_display_langCode_e]
                  }else{
                      ans_s = tab_o[this.p_att_s]
                  }
              }else{
                  ans_s = this.p_tabTitlePrefix_blc_s[this.p_display_langCode_e] + " " + (index_n+1)
              }

              return ans_s
          },
      },

      watch:{
          p_tabs_ao :{
              handler(){
                  this.local_tabs_ao = this.p_tabs_ao
              }
          }
      }
  }
</script>

<style scoped lang="scss">

    .style_Notification{
        width: 18px;
        height: 18px;
        padding: 2px;
        margin-top: -8px;
        position: relative;
        border-radius: 50%;
        color: white;
        background: #885ead;
        background: var(--color-purple_lite);
    }


    .tabText {
        /*padding: 8px 16px;*/
        position: relative;
        cursor: pointer;
        margin: 4px 2px;
        background: white;
        /*padding:  16px 20px;*/
        /*font-size: 20px;*/
        color: #501078;
        color: var(--color-purple);
        border: 2px solid transparent;

        &:hover{
            border-bottom: 2px solid black;
        }

        &.selectedTab {
            /*border-radius: 5px 5px 0 0;*/

            box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
            /*font-weight: bold;*/
            background: #501078;
            background: var(--color-purple);
            color : white;
            /*transform: translateY(4px);*/
            border: 2px solid white;

        }

    }

    .classDelete{
        margin-top: -2px;
        margin-right: -4px;
    }

    .lc_menuRTL{
        margin-left: -58px;
    }

    .lc_menuLTR{
        margin-right: -58px;
    }

    /* warRoomBody */
    .body{
        /*background: white;*/
        display:flow-root;
        /*box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);*/
    }

</style>
